export default __webpack_public_path__ + "static/media/large.9e03be14.jpg";